const actions = {
  ADD_CHATR_RECHARGE_PLAN: "ADD_CHATR_RECHARGE_PLAN",
  ADD_CHATR_RECHARGE_PLAN_SUCCESS: "ADD_CHATR_RECHARGE_PLAN_SUCCESS",
  ADD_CHATR_RECHARGE_PLAN_FAILED: "ADD_CHATR_RECHARGE_PLAN_FAILED",

  GET_CHATR_RECHARGE_PLAN_DATA: "GET_CHATR_RECHARGE_PLAN_DATA",
  GET_CHATR_RECHARGE_PLAN_DATA_SUCCESS: "GET_CHATR_RECHARGE_PLAN_DATA_SUCCESS",
  GET_CHATR_RECHARGE_PLAN_DATA_FAILED: "GET_CHATR_RECHARGE_PLAN_DATA_FAILED",

  DELETE_CHATR_RECHARGE_PLAN: "DELETE_CHATR_RECHARGE_PLAN",
  DELETE_CHATR_RECHARGE_PLAN_SUCCESS: "DELETE_CHATR_RECHARGE_PLAN_SUCCESS",

  PREPARE_RECHARGE_PLAN_FORM: "PREPARE_RECHARGE_PLAN_FORM",

  RESET_CHATR_RECHARGE_PLAN: "RESET_CHATR_RECHARGE_PLAN",
  RESET_CHATR_RECHARGE_PLAN_MESSAGE: "RESET_CHATR_RECHARGE_PLAN_MESSAGE",

  addChatrRechargePlan: (data) => ({
    type: actions.ADD_CHATR_RECHARGE_PLAN,
    payload: { data },
  }),
  addChatrRechargePlanSuccess: (rechargeMessage, rechargeResult) => ({
    type: actions.ADD_CHATR_RECHARGE_PLAN_SUCCESS,
    rechargeMessage,
    rechargeResult,
  }),
  addChatrRechargePlanFailed: (rechargeError) => ({
    type: actions.ADD_CHATR_RECHARGE_PLAN_FAILED,
    rechargeError,
  }),

  getChatrRechargePlanData: (networkID) => ({
    type: actions.GET_CHATR_RECHARGE_PLAN_DATA,
    networkID,
  }),
  getChatrRechargePlanDataSuccess: (rechargePlanData) => ({
    type: actions.GET_CHATR_RECHARGE_PLAN_DATA_SUCCESS,
    rechargePlanData,
  }),
  getChatrRechargePlanDataFailed: (rechargePlanError) => ({
    type: actions.GET_CHATR_RECHARGE_PLAN_DATA_FAILED,
    rechargePlanError,
  }),

  deleteChatrRechargePlan: (planId, status, networkID) => ({
    type: actions.DELETE_CHATR_RECHARGE_PLAN,
    payload: { planId, status, networkID },
  }),
  deleteChatrRechargePlanSuccess: (deleteChatrRechargeMessage,deleteChatrRechargeResult,) => ({
    type: actions.DELETE_CHATR_RECHARGE_PLAN_SUCCESS,
    deleteChatrRechargeMessage,
    deleteChatrRechargeResult,
  }),

  prepareChatrRechargePlanForm: () => ({
    type: actions.PREPARE_RECHARGE_PLAN_FORM,
  }),
  resetChatrRechargePlan: () => ({
    type: actions.RESET_CHATR_RECHARGE_PLAN,
  }),
  resetChatrRechargePlanMessage: () => ({
    type: actions.RESET_CHATR_RECHARGE_PLAN_MESSAGE,
  }),
};
export default actions;
